import {
  type HttpClientConfig,
  type HttpClientInterface,
  HttpHeaders,
} from 'core/infra/http/HttpClient'

import { type RawTenderOfferListResponse } from '../ui/types'
import { mapApiToTenderOfferList } from './TenderAdapter'

type PendingTendersRepositoryDependencies = {
  httpClient: HttpClientInterface
}

const BASE_URL = '/carrier/tenders/pending'

export class PendingTendersRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: PendingTendersRepositoryDependencies) {
    this.httpClient = httpClient
  }

  async getPendingTenders({
    token,
    config,
  }: {
    token: string
    config?: Partial<HttpClientConfig>
  }) {
    const headers = {
      Authorization: `Bearer ${token}`,
    }

    const response = await this.httpClient.get<RawTenderOfferListResponse>(`${BASE_URL}`, {
      ...config,
      headers: new HttpHeaders({
        ...headers,
      }),
    })

    return mapApiToTenderOfferList(response.data)
  }
}
